import {axiosInstance} from "axiosConfig";
import {toMultipartFormData} from "../utils/toMultipartFormData";

export class BaseCrudService<TDto> {
  private readonly url: string;
  private readonly multipart: boolean;

  constructor(url: string, multipart: boolean = false) {
    this.url = url;
    this.multipart = multipart;
  }

  getList = (params: { limit?: number; offset?: number; filter?: any } = {}): Promise<TDto[]> => {
    const requestParams = {
      offset: params?.offset,
      limit: params?.limit,
      ...params.filter,
    };

    return axiosInstance
      .get(this.url, {params: requestParams})
      .then((response) => {
        return response.data;
      });
  };

  getById = (params: { id: any }): Promise<TDto> => {
    return axiosInstance
      .get(`${this.url}/${params.id}`)
      .then((response) => {
        return response.data;
      });
  };

  create = (params: { data: any }): Promise<TDto> => {
    let requestData: any = params.data;
    let headers = undefined;

    console.log(requestData);
    console.log(this.multipart);

    if (this.multipart) {
      requestData = toMultipartFormData(requestData);
      headers = {"Content-Type": "multipart/form-data"}
    }

    return axiosInstance
      .post(this.url, requestData, {headers})
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.warn(error);
        return Promise.reject(error.response.data);
      });
  };

  update = (params: { id: any; data: any }): Promise<TDto> => {
    let requestData: any = params.data;
    let headers = undefined;

    if (this.multipart) {
      requestData = toMultipartFormData(requestData);
      headers = {"Content-Type": "multipart/form-data"}
    }

    return axiosInstance
      .put(`${this.url}/${params.id}`, requestData, {headers})
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.warn(error);
        return Promise.reject(error.response.data);
      });
  };

  delete = (params: { id: any; }): Promise<void> => {
    return axiosInstance
      .delete(`${this.url}/${params.id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.warn(error);
        return Promise.reject(error.response.data);
      });
  }
}
